import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  segment_list: [],
  selected_segments: null,
  openAIPanel: false,
  showTC: false,
  aiPanelHotels: [],
  biddingLevel: "hotels",
  triggerLoadTable: false
};
export const aiConnectSlice = createSlice({
  name: "aiConnectSlice",
  initialState: initialState,
  reducers: {
    updateSelectedSegments: (state,action) => {
      state.selected_segments = action.payload;
    },
    updateSegmentList: (state, action) => {
      state.segment_list = action.payload;
    },
    toggleAIPanel : (state, action) => {
      state.openAIPanel = action.payload;
    },
    toggleShowTC: (state, action) => {
      state.showTC = action.payload;
    },
    updateAIPanelHotels: (state, action) => {
      state.aiPanelHotels = action.payload;
    },
    updateBiddingLevel: (state, action) => {
      state.biddingLevel = action.payload;
    },
    updateTriggerLoadTable: (state, action) => {
      state.triggerLoadTable = action.payload;
    },
    resetAIConnect: () => initialState
  },
});

export const {
  updateSegmentList,
  updateSelectedSegments,
  toggleAIPanel,
  toggleShowTC,
  updateAIPanelHotels,
  resetAIConnect,
  updateBiddingLevel,
  updateTriggerLoadTable
} = aiConnectSlice.actions;
export default aiConnectSlice.reducer;
